import { useEffect, useState } from 'react';

const useFontLoader = (fontData,family) => {
    const [fontCss, setFontCss] = useState(null);

    useEffect(() => {
        if (fontData) {
            let css = '';
            Object.entries(fontData).forEach(([weight, url]) => {
                css += `
          @font-face {
            font-family: ${family};
            font-style: normal;
            font-weight: ${weight === 'regular' ? 400 : weight};
            src: url(${url}) format('truetype');
          }
        `;
            });
            setFontCss(css);
        }
    }, [fontData]);

    return fontCss;
};

export default useFontLoader;
